// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Button } from "../../../../components/wpl/button/src/index";

const backgroundStyles = css`
    display: flex;
    flex-direction: column;
    margin: auto 16px;
    background-image: url(https://wac-cdn.atlassian.com/dam/jcr:4b129f91-c947-46e4-b1b9-e5949c2f1a7a/bg_hv.svg?cdnVersion=1223);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    align-items: stretch;
    overflow: hidden;
    text-align: center;
    gap: 24px;

    ${media.above.sm} {
        flex-direction: row;
        text-align: left;
        gap: 0;
    }
`;

const titleImageStyles = css`
    flex: 1 25%;
    display: flex;
    justify-content: center;
    padding-top: 34px;
    box-sizing: border-box;

    ${media.above.sm} {
        padding: ${token("space.200")};
    }

    img {
        max-width: 100%;
        width: 198px;
    }
`;

const descriptionStyles = css`
    display: flex;
    flex: 1 75%;
    flex-direction: column;
    align-items: center;
    padding-bottom: 22px;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
    gap: 24px;

    ${media.above.sm} {
        gap: 0;
        flex-direction: row;
        padding-bottom: 0;
    }
    ${media.above.md} {
        flex: 1 58.33333%;
    }
`;

const descriptionTextColumnStyles = css`
    flex: 1 100%;
    box-sizing: border-box;

    ${media.above.sm} {
        padding-bottom: 22px;
        padding-top: 16px;
    }
`;

const descriptionButtonStyles = css`
    flex: 1 0%;
    box-sizing: border-box;
    font-weight: 500;
    ${media.above.sm} {
        padding-left: 16px;
    }
`;

const locationStyles = css`
    flex: 1 16.66666%;
    padding: 0 ${token("space.200")} 0 ${token("space.200")};
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;

    img {
        vertical-align: bottom;
        width: 100%;
    }

    ${UNSAFE_media.below.md} {
        display: none;
    }
`;

export const AdBanner = () => {
    const intl = useIntl();

    const tagline = (
        <FormattedMessage
            id="AdBanner.descriptionTagline.onDemand"
            defaultMessage={"On demand"}
        />
    );
    const description = (
        <FormattedMessage
            id="AdBanner.description.campaignOct23.onDemand"
            defaultMessage={
                "Catch the keynote and other sessions from our biggest service management event of the year."
            }
        />
    );
    const ctaText = intl.formatMessage({
        id: "AdPattern.GetYourTicketButton.onDemand",
        defaultMessage: "Watch now"
    });
    const ctaUrl =
        "https://events.atlassian.com/highvelocity?ref=High_Velocity&utm_source=marketing&utm_campaign=on-demand&utm_content=lifted_banner_homepage_11.8&utm_medium=website";

    return (
        <div css={backgroundStyles}>
            <div css={titleImageStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/dam/jcr:e1f31cb5-84ff-4b60-99f5-f8b932c82f1e/logo_high-velocity.svg?cdnVersion=1223"
                    alt={intl.formatMessage({
                        id: "AdPattern.HighVelocityTextLogoAlt",
                        defaultMessage: "High velocity text logo"
                    })}
                />
            </div>
            <div css={descriptionStyles}>
                <div css={descriptionTextColumnStyles}>
                    <p
                        css={css`
                            margin-bottom: 0;
                            margin-top: 0;
                        `}
                    >
                        <strong>{tagline}</strong>
                    </p>
                    <p
                        css={css`
                            margin-bottom: 0;
                            margin-top: 0;
                        `}
                    >
                        {description}
                    </p>
                </div>
                <div css={descriptionButtonStyles}>
                    <Button
                        size={"small"}
                        dataEventProps={{
                            "data-event-component": "linkButton",
                            "data-event-container": "banner-link-button"
                        }}
                        url={ctaUrl}
                        css={css`
                            white-space: nowrap;
                            font-weight: 500;
                        `}
                        text={ctaText}
                    />
                </div>
            </div>
            <div css={locationStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/dam/jcr:d09d8bd1-4313-4048-af08-9836bc0edb94/sydney.png?cdnVersion=1223"
                    alt={intl.formatMessage({
                        id: "AdPattern.OperaHouseImageAlt",
                        defaultMessage: "Sydney opera house"
                    })}
                />
            </div>
        </div>
    );
};
